
/* =========================================================
   RLC UNIVERSAL PRODUCT PAGE
   FAQ ACCORDION + BEFORE / AFTER SLIDER + PURCHASE CTA
========================================================= */

document.addEventListener('DOMContentLoaded', function () {

  /* =========================================================
     FAQ ACCORDION
  ========================================================= */

  const faqItems = document.querySelectorAll(
    '.rlc-product-page .rlc-faq__item'
  );

  if (faqItems.length) {

    faqItems.forEach(function (item) {

      const summary = item.querySelector('summary');
      const answer = item.querySelector('.rlc-faq__answer');

      if (!summary || !answer) return;

      /* Initial authored-open state */
      if (item.open) {
        answer.style.height = 'auto';
      }

      summary.addEventListener('click', function (event) {

        event.preventDefault();

        if (item.open) {
          closeFaq(item, answer);
        } else {
          openFaq(item, answer);
        }

      });

    });

  }

  function openFaq(item, answer) {

    item.open = true;
    answer.style.height = '0px';

    /* Force layout */
    answer.offsetHeight;

    answer.style.height = answer.scrollHeight + 'px';

    answer.addEventListener(
      'transitionend',
      function handleOpen(event) {

        if (event.propertyName !== 'height') return;

        if (item.open) {
          answer.style.height = 'auto';
        }

        answer.removeEventListener(
          'transitionend',
          handleOpen
        );

      }
    );

  }

  function closeFaq(item, answer) {

    answer.style.height = answer.scrollHeight + 'px';

    /* Force layout */
    answer.offsetHeight;

    answer.style.height = '0px';

    answer.addEventListener(
      'transitionend',
      function handleClose(event) {

        if (event.propertyName !== 'height') return;

        item.open = false;

        answer.removeEventListener(
          'transitionend',
          handleClose
        );

      }
    );

  }


  /* =========================================================
     BEFORE / AFTER SLIDER
  ========================================================= */

  const beforeAfterSliders = document.querySelectorAll(
    '.rlc-product-page [data-rlc-before-after]'
  );

  if (beforeAfterSliders.length) {

    beforeAfterSliders.forEach(function (slider) {

      const range = slider.querySelector(
        '.rlc-before-after__range'
      );

      if (!range) return;

      function updateBeforeAfter() {

        slider.style.setProperty(
          '--rlc-before-after-position',
          range.value + '%'
        );

      }

      range.addEventListener('input', updateBeforeAfter);

      updateBeforeAfter();

    });

  }


  /* =========================================================
     PRODUCT PURCHASE CTA — R1 CUSTOM SHOPIFY THEME

     Scrolls custom product-description CTA buttons to
     the existing product purchase area:

     - Product title
     - Size swatches
     - Price
     - Quantity
     - Add to Cart

     Does not interfere with Shopify's cart functionality.
  ========================================================= */

  document.querySelectorAll(
    '.rlc-product-page .rlc-product-buy-link'
  ).forEach(function (link) {

    link.addEventListener('click', function (event) {

      event.preventDefault();

      /* Locate R1's product information container */
      const purchaseArea = document.querySelector(
        '.product-info'
      );

      if (!purchaseArea) {
        console.warn('RLC: Product info area not found.');
        return;
      }

      /* =====================================================
         STICKY HEADER OFFSET
      ====================================================== */

      const header = document.querySelector(
        '.site-header, ' +
        '.header-wrapper, ' +
        '.shopify-section-header-sticky'
      );

      let headerOffset = 30;

      if (header) {

        const headerStyle = window.getComputedStyle(header);

        if (
          headerStyle.position === 'fixed' ||
          headerStyle.position === 'sticky'
        ) {

          headerOffset += header.getBoundingClientRect().height;

        }

      }

      /* =====================================================
         CALCULATE SCROLL POSITION
      ====================================================== */

      const targetY =
        purchaseArea.getBoundingClientRect().top +
        window.pageYOffset -
        headerOffset;

      /* =====================================================
         SMOOTH SCROLL
      ====================================================== */

      window.scrollTo({
        top: Math.max(0, targetY),
        behavior: 'smooth'
      });

    });

  });


});
